import React from "react"
import { useTranslation } from "gatsby-plugin-react-i18next"
import { Container, Section, SectionHead } from "src/components/common"
import { Steps, Num, ValuesTitle, Values } from "./styles"

export const Process = () => {
  const { t } = useTranslation()
  const steps = t("process:steps", { returnObjects: true })
  const values = t("process:values", { returnObjects: true })

  return (
    <Section id="process" aria-labelledby="process-title" $tone="soft">
      <Container>
        <SectionHead
          id="process-title"
          title={t("process:headline")}
          lead={t("process:lead")}
        />
        <Steps>
          {steps.map((step, index) => (
            <li key={index}>
              <Num aria-hidden="true">{index + 1}</Num>
              <h3>{step.title}</h3>
              <p>{step.content}</p>
            </li>
          ))}
        </Steps>
        <ValuesTitle>{t("process:values_title")}</ValuesTitle>
        <Values>
          {values.map((value, index) => (
            <li key={index}>
              <h4>{value.title}</h4>
              <p>{value.content}</p>
            </li>
          ))}
        </Values>
      </Container>
    </Section>
  )
}
